import FormImgColor from './Form/FormImgColor'
import api from '../../../utils/api'
import { useState, useEffect } from 'react'
/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'

function EditImgColor({ id, handleSubmit, handleOnSuccess, btCancelAction }) {
    const [img, setImg] = useState("")
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {

        api.get(`/color/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            if (response) {
                setImg(response.data.color.image)
            }

        })
    }, [token, id])

    async function updateImgColor(obj) {
        /* let paramsName = "empty" */
        let msgType = 'success'
        //check if accessory exists
        if (!id) {
            setFlashMessage("O id é obrigatório", 'error')
            return
        }

        const formData = new FormData()
        await Object.keys(obj).forEach((key) => formData.append(key, obj[key]))



        const data = await api.patch(`/color/img/update/${id}`, formData, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            }
        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)


        if (msgType !== 'error') {

            handleOnSuccess()
        }






    }

    return (
        <FormImgColor title="Editar Imagem" btnText="Salvar" handleSubmit={updateImgColor} id={id} dataImg={img} btCancelAction={btCancelAction} />
    )
}

export default EditImgColor